module.exports = __webpack_public_path__ + "static/rcc-pfs-graph-c8a18e31cc9fc4b2675300a418fbd876.png";